import React from 'react';
import { EmptyState, useEditContext } from '@xingternal/pages-common';

import { JOBMANAGER_URL, XING_JOBS_URL } from './Jobs/config';

type JobsEmptyStateProps = { statusCode?: 404 | undefined };

const JobsEmptyState: React.FC<JobsEmptyStateProps> = ({ statusCode }) => {
  const { isEditor } = useEditContext();
  return (
    <EmptyState
      headlineCopyKey={
        isEditor
          ? 'EP_JOBS_EMPTYSTATE_HEADER'
          : 'EP_JOBS_PUBLIC_EMPTYSTATE_HEADER'
      }
      textCopyKey={
        isEditor ? 'EP_JOBS_EMPTYSTATE_BODY' : 'EP_JOBS_PUBLIC_EMPTYSTATE_BODY'
      }
      statusCode={statusCode}
      buttonProps={{
        copyKey: isEditor
          ? 'EP_JOBS_EMPTYSTATE_CTA'
          : 'EP_JOBS_PUBLIC_EMPTYSTATE_CTA',
        href: isEditor ? JOBMANAGER_URL : XING_JOBS_URL,
      }}
    />
  );
};

export default JobsEmptyState;
